import { render, staticRenderFns } from "./performance_rates_by_year.vue?vue&type=template&id=96dcf760&scoped=true"
import script from "./performance_rates_by_year.vue?vue&type=script&lang=js"
export * from "./performance_rates_by_year.vue?vue&type=script&lang=js"
import style0 from "./performance_rates_by_year.vue?vue&type=style&index=0&id=96dcf760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dcf760",
  null
  
)

export default component.exports